import { io } from "socket.io-client";
import Swal from "sweetalert2";

export const socket = io(process.env.REACT_APP_API_URL, {
  transports: ["websocket"],
  withCredentials: true,
});

// ⭐ LƯU USER ID SAU KHI LOGIN
export let currentUserId = null;

try {
  const storedUser = localStorage.getItem("user");
  if (storedUser) {
    const parsed = JSON.parse(storedUser);
    if (parsed?.id) {
      currentUserId = parsed.id;
    }
  }
} catch (e) {
  // Ignore JSON parse errors
}

export const registerSocketUser = (userId) => {
  currentUserId = userId;
  if (socket.connected) {
    socket.emit("register", userId);
  }
};

// ⭐ TỰ ĐỘNG REGISTER LẠI MỖI KHI SOCKET CONNECT HOẶC RECONNECT
socket.on("connect", () => {
  if (currentUserId) {
    socket.emit("register", currentUserId);
  }
});

// ⭐ LẮNG NGHE SỰ KIỆN FORCE LOGOUT KHI ĐĂNG NHẬP Ở THIẾT BỊ KHÁC
socket.on("force_logout", (data) => {
  console.warn("⚠️ Bị kick-out do đăng nhập thiết bị khác:", data);
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("modules");
  localStorage.removeItem("permissions");

  Swal.fire({
    title: "Đăng xuất tài khoản",
    text:
      data?.message ||
      "Tài khoản của bạn vừa đăng nhập trên một thiết bị khác. Phiên làm việc trên thiết bị này đã kết thúc.",
    icon: "warning",
    confirmButtonColor: "#e11d48",
    confirmButtonText: "Đăng nhập lại",
    allowOutsideClick: false,
    allowEscapeKey: false,
  }).then(() => {
    window.location.href = "/login";
  });

  // Tự động chuyển hướng sau 4 giây nếu người dùng không bấm
  setTimeout(() => {
    window.location.href = "/login";
  }, 4000);
});
